export const Completed = () => {
  return (
    <>
      <div className="max-w-2xl mx-auto p-6 text-center">
        {/*
          Uses the error ramp step rather than the `danger` semantic token: the colour is
          inherited from the original text-red-600, but "already completed" is informational,
          not an error. Red for this state looks like a pre-existing design slip worth
          revisiting — deliberately not re-coloured here, since that is a design change.
        */}
        <h2 className="text-2xl font-semibold text-error-50 mb-4"> Reference Completed</h2>
        <p className="text-grey-200 leading-relaxed">
          This peer reference has already been completed.
        </p>
      </div>
    </>
  );
};
